import { useCallback, useRef, useState } from 'react'
import { ErrorConstant, ReportService } from 'utility'

const GENERIC_REPORT_ERROR = 'Error al generar el reporte. Intente nuevamente.'

const readErrorMessage = (err, status) => {
    if (status === 400) {
        const payload = err?.error
        if (typeof payload === 'string' && payload.trim()) return payload
        if (typeof payload?.message === 'string' && payload.message.trim()) {
            return payload.message
        }
        if (typeof payload?.Message === 'string' && payload.Message.trim()) {
            return payload.Message
        }
        if (typeof payload?.ErrorMessage === 'string' && payload.ErrorMessage.trim()) {
            return payload.ErrorMessage
        }
        return payload ? String(payload) : 'TemplateId inválido.'
    }
    return GENERIC_REPORT_ERROR
}

export const GetAuditorSummary = () => {
    const [data, setData] = useState(null)
    const [error, setError] = useState('')
    const [errorStatus, setErrorStatus] = useState(null)
    const [loading, setLoading] = useState(false)
    const [filter, setFilter] = useState(null)
    const requestIdRef = useRef(0)

    const filterChanged = useCallback(filterData => {
        requestIdRef.current += 1
        const requestId = requestIdRef.current
        setFilter(filterData)
        setLoading(true)
        setError('')
        setErrorStatus(null)

        const fetchData = async () => {
            try {
                const result = await ReportService.getAuditorSummary(filterData)
                if (requestId !== requestIdRef.current) return
                setData(result || null)
            } catch (err) {
                if (requestId !== requestIdRef.current) return
                const status = err?.status || 500
                setErrorStatus(status)
                setError(readErrorMessage(err, status))
                setData(null)
            } finally {
                if (requestId === requestIdRef.current) {
                    setLoading(false)
                }
            }
        }

        fetchData()
    }, [])

    return {
        data,
        error,
        errorStatus,
        loading,
        filter,
        filterChanged,
        defaultError: ErrorConstant.default,
    }
}
